import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The Definitions tab replaces the Memories page. Both surfaces ship until the
 * flag is on everywhere, and the tab, its routes, and anything linking to
 * either one must agree, so they all read this hook. The same flag gates the
 * backend writing assumptions as definitions, since neither half is useful
 * without the other.
 */
export function useDefinitionsTabEnabled(): boolean {
  const { agentDefinitionsReviewTab } = useFlags();
  return Boolean(agentDefinitionsReviewTab);
}
